module.exports = {
      id: "comm-technology-usage",
      viewBox: "0 0 366.545 49.888",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-technology",
      toString: function () {
        return this.url;
      }
    }